import { Button, Dialog, DialogContent, DialogTitle, Divider, FormHelperText, Grid, Stack, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import DraggablePaper from "../common/DraggablePaper";
import { CONTENT_COLOR, MAIN_HEADER_COLOR } from "../../models/Constants";
import { DragEvent, useState } from "react";
import { Close } from "@mui/icons-material";

export type AddFileQuestionProps = {
    onOK: (data: any) => void;
    onCancel: () => void;
};

export const AddFileQuestionDialog = (props: AddFileQuestionProps) => {
    //#region fields
    const { onOK, onCancel } = props;

    const [questionFile,setQuestionFile] = useState<File | null>(null)
    const [fileContent,setFileContent] = useState(null)
    const [dragIsOverFile,setDragIsOverFile] = useState(false)

    const { control, handleSubmit, formState: { errors }, setValue, getValues, clearErrors, setError } = useForm<any>({
        mode: "all",
        criteriaMode: "all",
        defaultValues: null,
    })
    //#endregion fields

    //#region methods

    const handleShowError = () =>{
        clearErrors()
        let count = 0
        if(!(questionFile instanceof File) || !questionFile)
        {
            count++
            setError("questionFile",{ type: 'custom', message:"必須項目です。入力してください。"})
        }
        if(!(questionFile?.type === 'text/plain') && (questionFile instanceof File))
        {
            count++
            setError("fileFormat",{ type: 'custom', message:'指定されたファイルは利用できません。'})
        }
        return count
    }

    // Submitイベント
    const handleEditSubmit = (value: any, event: any) => {
        let count = handleShowError()
        if(count == 0)
        {
            const request = createRequestData(value);
            onOK(request);
        }
    }
    
    // FormデータからRequestデータを作成する
    const createRequestData = (formValue : any) => {       
        let request = {
            ...formValue,
            file: questionFile,
            content: fileContent
        };
        return request;
    }

    const handleSelectFile = (event:any) => {
        const selectedFile = event.target.files && event.target.files[0];
        setQuestionFile(selectedFile || null);
        if (selectedFile && selectedFile.type === 'text/plain') {
            const reader = new FileReader();
            reader.onload = (e:any) => {
                let text =  e.target.result;
                if(text.indexOf('[') == -1)
                {
                    const firstIndex = text.indexOf('{');
                    const lastIndex = text.lastIndexOf('}');
                    if (firstIndex !== -1 && lastIndex !== -1) {
                        text = text.substring(0, firstIndex) + '[' + text.substring(firstIndex + 1, lastIndex) + ']' + text.substring(lastIndex + 1);
                    }
                }

                try {
                    const json = JSON.parse(text);
                    setFileContent(json);
                } 
                catch (error) {
                    alert('Invalid JSON format in the .txt file');
                }
            };
            reader.readAsText(selectedFile);
        }
    }

    const handleDragOverFile =  (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setDragIsOverFile(true);
    }

    const handleDragLeaveFile = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        const { relatedTarget } = event;
        if (!relatedTarget || !event.currentTarget.contains(relatedTarget as any)) {
            dragIsOverFile && setDragIsOverFile(false);
        }
    }

    const handleDropFile = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDragIsOverFile(false);
        const droppedFiles = Array.from(event.dataTransfer.files);
        if(droppedFiles){
            setQuestionFile(droppedFiles[0]);
            if (droppedFiles && droppedFiles[0].type === 'text/plain') {
                const reader = new FileReader();
                reader.onload = (e:any) => {
                    let text =  e.target.result;
                    if(text.indexOf('[') == -1)
                    {
                        const firstIndex = text.indexOf('{');
                        const lastIndex = text.lastIndexOf('}');
                        if (firstIndex !== -1 && lastIndex !== -1) {
                          text = text.substring(0, firstIndex) + '[' + text.substring(firstIndex + 1, lastIndex) + ']' + text.substring(lastIndex + 1);
                        }
                    }
    
                    try {
                        const json = JSON.parse(text);
                        setFileContent(json);
                    } 
                    catch (error) {
                        alert('Invalid JSON format in the .txt file');
                    }
                };
                reader.readAsText(droppedFiles[0]);
            }
        } 
            
    }

    const handleDeleteFileSelected = () =>{
        clearErrors()
        setQuestionFile(null)
    }
    //#endregion methods

    return (
        <>
            <Dialog open={true} maxWidth={"sm"} fullWidth
                PaperComponent={
                    DraggablePaper
                }
            >
                <DialogTitle 
                    onMouseOver={(e : any) => e.target.style.cursor = 'move'}
                    style={{ paddingTop: '2px', paddingBottom: '2px', background: MAIN_HEADER_COLOR, color: 'white' }}
                >
                    <Typography variant="h5" color={CONTENT_COLOR}>質問ファイル更新</Typography>
                </DialogTitle>
                <Divider/>
                <DialogContent style={{paddingTop: '10px', display: 'flex', alignItems: 'flex-end'}} >
                    <div style={{width: '100%'}}>
                        <form onSubmit={handleSubmit(handleEditSubmit)}>
                            <Stack>
                                <Stack direction={"column"} spacing={0}>
                                    {
                                        !( questionFile instanceof File) ?
                                        <>
                                            <Grid
                                                container
                                                mt={1}
                                                onDragOver={handleDragOverFile}
                                                onDragLeave={handleDragLeaveFile}
                                                onDrop={handleDropFile}
                                                sx={{
                                                    display: 'flex',
                                                    height: '12vh',
                                                    minHeight:"80px",
                                                    left:'10px',
                                                    right:"10px",
                                                    border: '1px dashed lightgray',
                                                    backgroundColor: dragIsOverFile ? 'lightgray' : 'white',
                                                    wordBreak:"break-all",
                                                    borderRadius:"8px"
                                                }}
                                            >
                                                <Grid item xs={8} justifyItems={"center"} alignSelf={"center"}>
                                                    <Typography>
                                                        ドラッグ&ドロップ
                                                    </Typography>
                                                    <Typography sx={{color:"grey"}}>
                                                        (.txt)
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} justifyItems={"center"} alignSelf={"center"}>
                                                <Button variant="outlined" color="inherit"  sx={{backgroundColor:'#cccccc'}} component="label">
                                                        ファイル選択
                                                    <input type="file" hidden onChange={(e:any) =>handleSelectFile(e)} accept=".txt"/>
                                                </Button>
                                                </Grid>
                                            </Grid>
                                            
                                            {
                                                !!errors?.questionFile &&
                                                <FormHelperText style={{ color: 'red',marginLeft:"20px"}}>{errors?.questionFile?.message as any}
                                                </FormHelperText>
                                            }
                                        </>
                                        :
                                        <Grid
                                            container
                                            mt={1}
                                            sx={{
                                                display: 'flex',
                                                height: '12vh',
                                                minHeight:"80px",
                                                left:'10px',
                                                right:"10px",
                                                border: '1px solid lightgray',
                                                wordBreak:"break-all",
                                                borderRadius:"8px"
                                            }}
                                        >
                                            <Grid item xs={8} justifyItems={"flex-start"} alignSelf={"center"}>
                                                <Stack direction={"column"} ml={3} spacing={0.5}>
                                                    <Typography sx={{alignSelf:'center', color:!errors?.fileFormat?"#3030ff":"red", fontSize:"2vh", cursor:"pointer", '&:hover':{textDecoration: 'underline'}}} noWrap onClick={()=>{window.open(URL.createObjectURL(questionFile), '_blank', 'noopener,noreferrer')}} >{questionFile?.name}</Typography>
                                                    <Typography sx={{fontSize:'1.5vh',color:!errors?.fileFormat? 'grey' : 'red'}}  noWrap>{!errors?.fileFormat?'クリックするとファイルが表示されます。':errors?.fileFormat?.message as any}</Typography>
                                                </Stack>
                                            </Grid>
                                            <Grid item xs={1} sx={{alignSelf:'center', '&:hover':{color:CONTENT_COLOR}}}>
                                                <Close onClick={handleDeleteFileSelected}/>
                                            </Grid>
                                        </Grid>
                                    }
                                </Stack>
                                
                            </Stack>
                            <Stack direction='row' justifyContent="flex-end" gap={2} sx={{ mt: 4 }}>
                                <Button color="inherit" variant="contained" onClick={onCancel} sx={{fontWeight:'bold'}}>キャンセル</Button>
                                <Button variant="contained" type="submit" sx={{fontWeight:'bold'}}>保存</Button>
                            </Stack>
                        </form>
                    </div>                    
                </DialogContent>
            </Dialog>
        </>
    )
}
export default AddFileQuestionDialog;